import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../shared/Button';
import Input from '../../shared/Input';

import { getFlowsTheme } from '../../../util/utils';

const NoteListItem = ({
  note,
  users = [],
  procedureFlow,
  canEdit,
  isEditing,
  editingText,
  onEditTextChange,
  onEditStart,
  onEditCancel,
  onEditSave,
  saving,
}) => {
  const getUserName = (uid) => {
    const user = users?.find((u) => u.uid === uid);
    return user ? `${user.firstName} ${user.lastName}` : '';
  };
  const authorName = getUserName(note.userId) || note.authorName || '';

  return (
    <div className="case-note">
      <div>
        <div className="d-flex">
          <div className="font-bold">{authorName}</div>
          {note.external && <span className="m-l-md" style={{ color: getFlowsTheme(procedureFlow)?.main }}>External Note</span>}
        </div>

        <div className="d-flex">
          {canEdit && !isEditing && (
            <div
              className="case-note_edit-action pointer m-r-md"
              style={{ color: getFlowsTheme(procedureFlow)?.main }}
              onClick={onEditStart}
            >
              Edit
            </div>
          )}
          {!!note.date && (
            <div className="secondary">{`${note.date?.local()?.format('MMM Do YY')} | ${note.date?.local()?.format('HH:mm')}`}</div>
          )}
        </div>
      </div>

      {isEditing ? (
        <div className="case-note_edit-form">
          <Input
            multiline
            minRows={3}
            value={editingText}
            onChange={(e) => onEditTextChange(e.target.value)}
            placeholder="Update your note"
            autoFocus
          />
          <div className="case-note_edit-actions">
            <Button
              type="cancel"
              text="Cancel"
              onClick={onEditCancel}
              disabled={saving}
            />
            <Button
              text="Save note"
              type="submit"
              onClick={onEditSave}
              disabled={!editingText.trim().length || editingText === note.text || saving}
              loading={saving}
            />
          </div>
        </div>
      ) : (
        <div>
          {note.text}
        </div>
      )}
    </div>
  );
};

NoteListItem.propTypes = {
  note: PropTypes.shape({
    authorName: PropTypes.string,
    date: PropTypes.object,
    external: PropTypes.bool,
    text: PropTypes.string,
    userId: PropTypes.string,
  }),
  users: PropTypes.array,
  procedureFlow: PropTypes.string,
  canEdit: PropTypes.bool,
  isEditing: PropTypes.bool,
  editingText: PropTypes.string,
  onEditTextChange: PropTypes.func,
  onEditStart: PropTypes.func,
  onEditCancel: PropTypes.func,
  onEditSave: PropTypes.func,
  saving: PropTypes.bool,
};

export default NoteListItem;
